// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2J3dc","notes":"Notes_notes__3FnfT","note":"Notes_note__1ugkS","markdown":"Notes_markdown__mIjDh"};